import ViewManager from '../../../managers/view';
import { tooltip } from '../../../util/on-load-helpers';

let animateHeightTimeout;

let animateHeight = (el, type = "open") => {
  // stop any current animations
  clearTimeout(animateHeightTimeout);

  // Get init inline styles
  let initStyles = getComputedStyle(el);

  // Get element height
  if (type === "open") {
    el.style.maxHeight = "none";
  }
  let height = el.offsetHeight;

  height += parseInt(initStyles.marginTop) + parseInt(initStyles.marginBottom);
  height = `${height}px`;

  // Remove added styles needed to compute true height or replace with stored initial styles
  initStyles.transition ? el.style.removeProperty("transition") : initStyles.transition;
  initStyles.webkitTransition ? el.style.removeProperty("webkitTransition") : initStyles.webkitTransition;
  initStyles.transition ? el.style.removeProperty("transition") : initStyles.transition;
  initStyles.visibility ? el.style.removeProperty("visibility") : initStyles.visibility;
  initStyles.maxHeight ? el.style.removeProperty("maxHeight") : initStyles.maxHeight;
  initStyles.height ? el.style.removeProperty("height") : initStyles.height;

  // get max-height transition time
  let partialArraySearch = (a, regex) => {
    for (var i = 0; i < a.length; i++) {
      if (a[i].search(regex) > -1) {
        return i;
      }
    }
    return -1;
  };
  let transitionDuration = initStyles.transition.split(", ");
  let transitionDurationIndex = partialArraySearch(transitionDuration, /max\-height/g);
  if (transitionDurationIndex !== -1) {
    transitionDuration = transitionDuration[transitionDurationIndex];
    transitionDuration = transitionDuration.split(" ")[1];
    transitionDuration = transitionDuration.indexOf("ms") !== -1 ? parseFloat(transitionDuration) * 100 : parseFloat(transitionDuration) * 1000;
  } else {
    transitionDuration = 1000;
  }

  // Animate height with acceptance for render/repaint time
  let createHeightAnimation = (start, finish, duration = transitionDuration) => {
    el.style.maxHeight = start;
    new Promise(r => {
      setTimeout(() => {
        el.style.maxHeight = finish;
        r();
      }, 50);
    }).then(() => {
      animateHeightTimeout = setTimeout(() => {
        el.style.maxHeight = finish === "0px" ? "0px" : "none";
      }, duration);
    });
  };

  // Apply maxHeight based on type
  switch (type) {
    case "open":
      createHeightAnimation("0px", height);
      return;

    case "close":
      createHeightAnimation(height, "0px");
      return;
  }
};

function toggleHandler(event) {
  // Debounce so we don't block the main thread (fixes INP issues)
  setTimeout(() => {
    event.stopPropagation();
    let preventScroll = this.dataset.lock !== undefined;
    let value = this.dataset.toggleFor,
      ElementToggle = event.target.parentNode.parentNode.parentNode.parentNode.parentNode.querySelector('[data-toggle="' + value + '"]'),
      ElementToggleFor = event.target.parentNode.parentNode.parentNode.parentNode.parentNode.querySelector('[data-toggle-for="' + value + '"]');
  
    if (ElementToggleFor.dataset.preventScroll) {
      var preventEl = document.querySelector(ElementToggleFor.dataset.preventScroll)
    }
  
    if (ElementToggle.classList.contains("hidden")) {
      if (preventScroll) document.body.classList.add('no-scroll');
      ElementToggleFor.setAttribute('aria-expanded', true);
      ElementToggle.setAttribute('aria-hidden', false);
      if (preventEl) {
        preventEl.style.overflow = "hidden";
      }
      if (ElementToggleFor.dataset.touchClose == "true") {
        ElementToggleFor.removeEventListener("click", toggleHandler);
        ElementToggleFor.addEventListener("touchstart", toggleHandler);
      }
      if (ElementToggle.dataset.heightAnimation == "true") {
        animateHeight(ElementToggle);
      }
      ElementToggle.classList.remove("hidden");
      if (!ElementToggleFor.querySelector(".fa")) return;
  
      if (ElementToggleFor.firstChild.classList === undefined) {
        ElementToggleFor.querySelector(".fa").classList.remove("fa-plus");
        ElementToggleFor.querySelector(".fa").classList.add("fa-minus");
      } else {
        ElementToggleFor.firstChild.classList.remove("fa-plus");
        ElementToggleFor.firstChild.classList.add("fa-minus");
      }
    } else {
      if (preventScroll) document.body.classList.remove('no-scroll');
      ElementToggleFor.setAttribute('aria-expanded', false);
      ElementToggle.setAttribute('aria-hidden', true);
      ElementToggle.classList.add("hidden");
      if (preventEl) {
        preventEl.style.removeProperty("overflow");
      }
      if (ElementToggleFor.dataset.touchClose == "true") {
        ElementToggleFor.removeEventListener("touchstart", toggleHandler);
        ElementToggleFor.addEventListener("click", toggleHandler);
      }
      if (ElementToggle.dataset.heightAnimation == "true") {
        animateHeight(ElementToggle, "close");
      }
      if (!ElementToggleFor.querySelector(".fa")) return;
  
      if (ElementToggleFor.firstChild.classList === undefined) {
        ElementToggleFor.querySelector(".fa").classList.remove("fa-minus");
        ElementToggleFor.querySelector(".fa").classList.add("fa-plus");
      } else {
        ElementToggleFor.firstChild.classList.remove("fa-minus");
        ElementToggleFor.firstChild.classList.add("fa-plus");
      }
    }
  
    // Invalidate view immediately to reflect instant change
    ViewManager.invalidate();
    // Invalidate view once complete
    ElementToggle.addEventListener("transitionend", () => ViewManager.invalidate(), false);
  }, 0);
}

function ReviewsHandler(event, control) {
  let currentTarget = event.target;
  currentTarget.classList.add("hidden");
  control.classList.remove("hidden");
  document.querySelectorAll("[data-review]").forEach(function(el, index) {
    if (currentTarget.dataset.moreReviews == "") return el.classList.remove("hidden");
    if (index > 1) el.classList.add("hidden");
  });
}

function setVideo() {
  let video = this.dataset.video + "&autoplay=1";
  document.querySelector("[data-video-replace]").src = video;
}

function printHandler(e) {
  e.preventDefault();
  window.print();
}

function getHeight(name) {
  var elementHeight = 0;
  document.querySelectorAll('[data-match-height="' + name + '"]').forEach(function(el) {
    if (el.offsetHeight > elementHeight) {
      elementHeight = el.offsetHeight;
    }
  });
  return elementHeight;
}

function insertData(el) {
  let value = el.dataset.insert,
    hotel = JSON.parse(sessionStorage.getItem("currentHotel")),
    search = JSON.parse(sessionStorage.getItem("currentSearch")),
    returnedSearch = JSON.parse(sessionStorage.getItem("returnedSearch"));

  if (value === "includes") {
    // let rooms = hotel.AccommodationAvailability[hotel.activeIndex].BestRoomOptions[0].RoomInclusions;
    // if (rooms.length > 0){
    //   let insert;
    //   for(let i = 0, l = rooms.length; i < l; i++) {
    //     insert += '<li>' + rooms[0] + '</li>';
    //   }
    //   el.innerHTML = '<ul class="list-bullet">' + insert + '</ul>';
    //   document.querySelector('[data-insert-for="includes"]').classList.remove('hidden');
    // }
  } else if (value === "rating") {
    let rating = "",
      ratingHalf,
      rate = hotel ? hotel.Rating : el.parentNode.dataset.rating;
    rate = typeof rate === "string" ? rate.replace(",", ".") : rate;
    ratingHalf = rate % 1 != 0 ? "<small>PLUS</small>" : "";

    for (let i = 0, l = Math.floor(+rate); i < l; i++) {
      rating += '<img src="/assets/img/citalia-star.svg" alt="Rating Icon"/>';
    }
    el.innerHTML = rating + ratingHalf;
  }
}

export function website() {
  const bodyElement = document.body;
  const cssLoadingClass = 'css-loading';

  if (bodyElement.classList.contains(cssLoadingClass)) {
    const bodyObserver = new MutationObserver((mutations) => {
      [...mutations].forEach((mutation) => {
        if (mutation.attributeName === 'class' && !bodyElement.classList.contains(cssLoadingClass)) {
          executeWebsiteFunc();
        }
      });
    });
    bodyObserver.observe(bodyElement, { attributes: true });
  } else {
    executeWebsiteFunc();
  }
}

function executeWebsiteFunc() {
  tooltip();
  matchHeight();

  // fix scroll position
  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }

  let moreReviewsControl = document.querySelector("[data-more-reviews]"),
    lessReviewsControl = document.querySelector("[data-less-reviews]");

  if (moreReviewsControl && lessReviewsControl) {
    moreReviewsControl.addEventListener("click", event => ReviewsHandler(event, lessReviewsControl));

    lessReviewsControl.addEventListener("click", event => ReviewsHandler(event, moreReviewsControl));
  }

  document.querySelectorAll("[data-video]").forEach(el => el.addEventListener("click", setVideo));

  document.querySelectorAll("[data-toggle-for]").forEach(el => el.addEventListener("click", toggleHandler));

  // print
  document.querySelectorAll(".print-button").forEach(el => el.addEventListener("click", printHandler));

  let elementInsert = document.querySelectorAll("[data-insert]");
  if (elementInsert.length) {
    elementInsert.forEach(insertData);
  }
}

function matchHeight() {
  let elements = [],
    elementsMatchHeight = document.querySelectorAll("[data-match-height]"),
    name,
    elementHeight;

  if (elementsMatchHeight.length) {
    elementsMatchHeight.forEach((el) => {
      name = el.dataset.matchHeight;
      if (elements.indexOf(name) === -1) {
        elements.push(name);
      }
    });

    for (let i = 0, l = elements.length; i < l; ++i) {
      elementHeight = 0;
      elementHeight = getHeight(elements[i]);
      document.querySelectorAll('[data-match-height="' + elements[i] + '"]').forEach(item => (item.style.height = elementHeight + "px"));
    }
  }
}
